import React from 'react';
import { upperCase } from 'lodash/fp';
import PropTypes from 'prop-types';
import { FinanceType } from '@upstart/harmony/lib/constants';
import { Dropdown, MenuItem } from 'react-bootstrap';

function FinanceTypeDropdown(props) {
  const { financeType, setFinanceType, deal, updateDeal } = props;
  const onSelectFinanceType = f => {
    setFinanceType(f);
    if (deal) {
      // If there is a deal, update the financeType on that deal.
      updateDeal({ ...deal, financeType: f });
    }
  };
  const financeTypes = Object.entries(FinanceType).map(([, type]) => type);

  return (
    <Dropdown className="dropdown-trigger" id="user-dropdown-basic">
      <Dropdown.Toggle className="dropdown-label" id="user-dropdown-toggle">
        {upperCase(financeType)}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {financeTypes.map(f => (
          <MenuItem key={f} onSelect={() => onSelectFinanceType(f)}>
            {upperCase(f)}
          </MenuItem>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

FinanceTypeDropdown.propTypes = {
  financeType: PropTypes.string,
  setFinanceType: PropTypes.func,
  deal: PropTypes.object,
  updateDeal: PropTypes.func,
};

export default FinanceTypeDropdown;
